import m from 'mithril'

export default {
  view: (vnode) => {
    let map

    switch (vnode.attrs.currentScene) {
      case 'outside':
        map = require('./outside.jpg')
        break
      case 'tunnel-entrance':
        map = require('./tunnel-entrance.jpg')
        break
      case 'tunnel-recroom':
        map = require('./tunnel-recroom.jpg')
        break
      case 'tunnel-quarters':
        map = require('./tunnel-quarters.jpg')
        break
      case 'tunnel-headquarters':
        map = require('./tunnel-headquarters.jpg')
        break
      case 'tunnel-doctor':
          map = require('./tunnel-doctor.jpg')
          break
      case 'tunnel-reactor':
          map = require('./tunnel-reactor.jpg')
          break
      case 'tunnel-rails':
          map = require('./tunnel-rails.jpg')
          break
      case 'tunnel-exit':
        map = require('./tunnel-exit.jpg')
        break
      case 'recroom1':
        map = require('./recroom.jpg')
        break
      case 'recroom2':
        map = require('./recroom.jpg')
        break
      case 'quarters1':
        map = require('./quarters.jpg')
        break
      case 'quarters2':
        map = require('./quarters2.jpg')
        break
      case 'headquarters1':
        map = require('./headquarters.jpg')
        break
      case 'headquarters2':
        map = require('./headquarters.jpg')
        break
      case 'reactor1':
        map = require('./reactor.jpg')
        break
      case 'reactor2':
        map = require('./reactor2.jpg')
        break
      case 'rails1':
        map = require('./rails.jpg')
        break
      case 'rails2':
        map = require('./rails.jpg')
        break
      default:
        map = require('./journal-map.jpg')
    }

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-02-page`}>
        <img className="log-book-img" src={map}></img>
      </div>
    )
  },
}
